import { useCallback, useMemo, useState } from "react";

import { BankConnectConsentModal } from "../components/bank-connect-consent-modal";

import { BankConnectConsentContext, type BankConnectConsentProviderProps } from "./BankConnectConsentContext";

export const BankConnectConsentProvider = (props: BankConnectConsentProviderProps) => {
  const defaultModalOptions = useMemo(() => ({ modalOpen: false, providerName: "", onConsentGiven: () => {} }), []);
  const [{ modalOpen, providerName, onConsentGiven }, setModalOptions] = useState(defaultModalOptions);
  const [consentNeeded, setConsentNeeded] = useState(!!props.consentNeeded);

  const openBankConnectConsentModal = useCallback((providerName: string, onConsentGiven: () => void) => {
    setModalOptions({ modalOpen: true, providerName, onConsentGiven });
  }, []);

  const close = useCallback(() => setModalOptions(defaultModalOptions), [defaultModalOptions]);

  const consentHandlerWrapper = useCallback(async () => {
    await props.consentHandler();
    setConsentNeeded(false);
    onConsentGiven && onConsentGiven();
  }, [props, onConsentGiven]);

  return (
    <>
      <BankConnectConsentModal
        providerName={providerName}
        isOpen={modalOpen}
        consentHandler={consentHandlerWrapper}
        close={close}
      />
      <BankConnectConsentContext.Provider
        value={{ openBankConnectConsentModal, bankConnectConsentNeeded: consentNeeded, modalOpen }}
      >
        {props.children}
      </BankConnectConsentContext.Provider>
    </>
  );
};
